import { AFFILIATE_TYPE_CODES, COIRegistryEntry } from "../../COIRegistry.types";
import { COIRegistryFormState } from "./COIRegistryModal.types";

export const buildInitialFormState = (selectedRowData?: COIRegistryEntry): COIRegistryFormState => ({
  secClientId: selectedRowData?.SECClientId ?? "",
  affiliateTypeCode: selectedRowData?.AffiliateTypeCode ?? AFFILIATE_TYPE_CODES.ENTITY,
  affiliateEntityName: selectedRowData?.AffiliateEntityName ?? "",
  affiliateFirstName: selectedRowData?.AffiliateFirstName ?? "",
  affiliateMiddleName: selectedRowData?.AffiliateMiddleName ?? "",
  affiliateLastName: selectedRowData?.AffiliateLastName ?? "",
  relationshipToSECClient: selectedRowData?.RelationshipToSECClient ?? "",
  affiliateIndividualSECClient: selectedRowData?.AffiliateIndividualSECClient === "Y",
  comment: selectedRowData?.Comment ?? "",
  coiRestriction: (selectedRowData?.COIRestriction ?? "Y") === "Y",
});

export const validateCOIRegistryForm = (
  form: COIRegistryFormState
): { valid: boolean; errors: Record<string, string> } => {
  const errors: Record<string, string> = {};
  const emptyMsg = "Field cannot be empty";

  if (!form.secClientId.trim()) errors.secClientId = emptyMsg;

  if (form.affiliateTypeCode === AFFILIATE_TYPE_CODES.ENTITY) {
    if (!form.affiliateEntityName.trim()) errors.affiliateEntityName = emptyMsg;
  } else {
    if (!form.affiliateFirstName.trim()) errors.affiliateFirstName = emptyMsg;
    if (!form.affiliateLastName.trim()) errors.affiliateLastName = emptyMsg;
  }

  return { valid: Object.keys(errors).length === 0, errors };
};

export const buildCOIRegistryPayload = (
  form: COIRegistryFormState,
  selectedRowData?: COIRegistryEntry
): Partial<COIRegistryEntry> & { SECClientId: string; AffiliateTypeCode: string } => ({
  COIRegistryId: selectedRowData?.COIRegistryId,
  SECClientId: form.secClientId.trim(),
  AffiliateTypeCode: form.affiliateTypeCode,
  AffiliateEntityName: form.affiliateTypeCode === AFFILIATE_TYPE_CODES.ENTITY ? form.affiliateEntityName.trim() : undefined,
  AffiliateFirstName: form.affiliateTypeCode === AFFILIATE_TYPE_CODES.INDIVIDUAL ? form.affiliateFirstName.trim() : undefined,
  AffiliateMiddleName: form.affiliateTypeCode === AFFILIATE_TYPE_CODES.INDIVIDUAL ? form.affiliateMiddleName.trim() : undefined,
  AffiliateLastName: form.affiliateTypeCode === AFFILIATE_TYPE_CODES.INDIVIDUAL ? form.affiliateLastName.trim() : undefined,
  RelationshipToSECClient: form.relationshipToSECClient.trim(),
  AffiliateIndividualSECClient: form.affiliateIndividualSECClient ? "Y" : "N",
  Comment: form.comment.trim(),
  COIRestriction: form.coiRestriction ? "Y" : "N",
  Active: selectedRowData?.Active ?? "Y",
});
